import { useTheme } from '@/hooks/use-Theme';
import { motion } from 'framer-motion';

type Props = {
  duration?: number;
  color?: string;
  delay?: number;
  strokeWidth?: number;
  styleInactive?: boolean;
  width?: string;
  height?: string;
};

const Circuit = ({
  duration = 1,
  color = 'rgb(222 242 255)',
  delay = 0,
  strokeWidth = 2,
  styleInactive,
  width = '100%',
  height = '100%',
}: Props) => {
  const { theme } = useTheme();
  const isDarkTheme = theme === 'dark';

  const inactiveColor = isDarkTheme ? 'rgb(255 255 255)' : 'rgb(36 36 36)';

  const points = [
    'M 2231.519531 881.921875 C 2231.519531 891.761719 2223.550781 899.730469 2213.710938 899.730469 C 2203.878906 899.730469 2195.898438 891.761719 2195.898438 881.921875 C 2195.898438 872.089844 2203.878906 864.121094 2213.710938 864.121094 C 2223.550781 864.121094 2231.519531 872.089844 2231.519531 881.921875 ',
    'M 2158.148438 748.210938 C 2158.148438 758.039062 2150.179688 766.011719 2140.339844 766.011719 C 2130.511719 766.011719 2122.53125 758.039062 2122.53125 748.210938 C 2122.53125 738.371094 2130.511719 730.398438 2140.339844 730.398438 C 2150.179688 730.398438 2158.148438 738.371094 2158.148438 748.210938 ',
    'M 558.945312 917.898438 C 558.945312 927.730469 550.972656 935.710938 541.136719 935.710938 C 531.304688 935.710938 523.328125 927.730469 523.328125 917.898438 C 523.328125 908.058594 531.304688 900.089844 541.136719 900.089844 C 550.972656 900.089844 558.945312 908.058594 558.945312 917.898438 ',
    'M 1462.5 731.601562 C 1462.5 741.429688 1454.53125 749.410156 1444.691406 749.410156 C 1434.859375 749.410156 1426.878906 741.429688 1426.878906 731.601562 C 1426.878906 721.761719 1434.859375 713.789062 1444.691406 713.789062 C 1454.53125 713.789062 1462.5 721.761719 1462.5 731.601562 ',
    'M 2884.121094 960.511719 C 2884.121094 970.351562 2876.140625 978.320312 2866.308594 978.320312 C 2856.46875 978.320312 2848.5 970.351562 2848.5 960.511719 C 2848.5 950.679688 2856.46875 942.710938 2866.308594 942.710938 C 2876.140625 942.710938 2884.121094 950.679688 2884.121094 960.511719 ',
    'M 2843.191406 1500.511719 C 2843.191406 1510.351562 2835.21875 1518.320312 2825.378906 1518.320312 C 2815.550781 1518.320312 2807.578125 1510.351562 2807.578125 1500.511719 C 2807.578125 1490.679688 2815.550781 1482.710938 2825.378906 1482.710938 C 2835.21875 1482.710938 2843.191406 1490.679688 2843.191406 1500.511719 ',
    'M 2694.160156 1758.441406 C 2694.160156 1768.269531 2686.191406 1776.25 2676.351562 1776.25 C 2666.511719 1776.25 2658.539062 1768.269531 2658.539062 1758.441406 C 2658.539062 1748.601562 2666.511719 1740.628906 2676.351562 1740.628906 C 2686.191406 1740.628906 2694.160156 1748.601562 2694.160156 1758.441406 ',
    'M 2609.761719 2282.398438 C 2609.761719 2292.238281 2601.789062 2300.210938 2591.949219 2300.210938 C 2582.121094 2300.210938 2574.148438 2292.238281 2574.148438 2282.398438 C 2574.148438 2272.570312 2582.121094 2264.601562 2591.949219 2264.601562 C 2601.789062 2264.601562 2609.761719 2272.570312 2609.761719 2282.398438 ',
    'M 2409.21875 1749.300781 C 2409.21875 1759.128906 2401.25 1767.109375 2391.410156 1767.109375 C 2381.578125 1767.109375 2373.609375 1759.128906 2373.609375 1749.300781 C 2373.609375 1739.460938 2381.578125 1731.488281 2391.410156 1731.488281 C 2401.25 1731.488281 2409.21875 1739.460938 2409.21875 1749.300781 ',
    'M 1922.070312 1749.300781 C 1922.070312 1759.128906 1914.101562 1767.109375 1904.269531 1767.109375 C 1894.429688 1767.109375 1886.460938 1759.128906 1886.460938 1749.300781 C 1886.460938 1739.460938 1894.429688 1731.488281 1904.269531 1731.488281 C 1914.101562 1731.488281 1922.070312 1739.460938 1922.070312 1749.300781 ',
    'M 1170.621094 1648.441406 C 1170.621094 1658.269531 1162.640625 1666.25 1152.808594 1666.25 C 1142.96875 1666.25 1135 1658.269531 1135 1648.441406 C 1135 1638.601562 1142.96875 1630.628906 1152.808594 1630.628906 C 1162.640625 1630.628906 1170.621094 1638.601562 1170.621094 1648.441406 ',
    'M 3051.871094 1720.238281 C 3051.871094 1730.078125 3043.890625 1738.050781 3034.058594 1738.050781 C 3024.21875 1738.050781 3016.25 1730.078125 3016.25 1720.238281 C 3016.25 1710.410156 3024.21875 1702.441406 3034.058594 1702.441406 C 3043.890625 1702.441406 3051.871094 1710.410156 3051.871094 1720.238281 ',
    'M 1522.238281 802.570312 C 1522.238281 812.410156 1514.269531 820.378906 1504.441406 820.378906 C 1494.601562 820.378906 1486.628906 812.410156 1486.628906 802.570312 C 1486.628906 792.738281 1494.601562 784.769531 1504.441406 784.769531 C 1514.269531 784.769531 1522.238281 792.738281 1522.238281 802.570312 ',
    'M 1630.109375 523.769531 C 1630.109375 533.601562 1622.128906 541.570312 1612.300781 541.570312 C 1602.460938 541.570312 1594.488281 533.601562 1594.488281 523.769531 C 1594.488281 513.929688 1602.460938 505.960938 1612.300781 505.960938 C 1622.128906 505.960938 1630.109375 513.929688 1630.109375 523.769531 ',
    'M 1726.640625 881.921875 C 1726.640625 889.890625 1720.179688 896.351562 1712.210938 896.351562 C 1704.25 896.351562 1697.789062 889.890625 1697.789062 881.921875 C 1697.789062 873.960938 1704.25 867.5 1712.210938 867.5 C 1720.179688 867.5 1726.640625 873.960938 1726.640625 881.921875 ',
    'M 431.886719 724.171875 C 431.886719 732.140625 425.429688 738.601562 417.460938 738.601562 C 409.492188 738.601562 403.035156 732.140625 403.035156 724.171875 C 403.035156 716.210938 409.492188 709.75 417.460938 709.75 C 425.429688 709.75 431.886719 716.210938 431.886719 724.171875 ',
    'M 3315.988281 566.851562 C 3315.988281 574.820312 3309.53125 581.269531 3301.558594 581.269531 C 3293.589844 581.269531 3287.128906 574.820312 3287.128906 566.851562 C 3287.128906 558.878906 3293.589844 552.421875 3301.558594 552.421875 C 3309.53125 552.421875 3315.988281 558.878906 3315.988281 566.851562 ',
    'M 3110.089844 585.039062 C 3110.089844 593.011719 3103.628906 599.46875 3095.660156 599.46875 C 3087.691406 599.46875 3081.230469 593.011719 3081.230469 585.039062 C 3081.230469 577.078125 3087.691406 570.621094 3095.660156 570.621094 C 3103.628906 570.621094 3110.089844 577.078125 3110.089844 585.039062 ',
    'M 2558.78125 1659.378906 C 2558.78125 1667.339844 2552.320312 1673.800781 2544.351562 1673.800781 C 2536.378906 1673.800781 2529.921875 1667.339844 2529.921875 1659.378906 C 2529.921875 1651.410156 2536.378906 1644.949219 2544.351562 1644.949219 C 2552.320312 1644.949219 2558.78125 1651.410156 2558.78125 1659.378906 ',
    'M 2978.648438 1737.039062 C 2978.648438 1745.011719 2972.191406 1751.46875 2964.21875 1751.46875 C 2956.25 1751.46875 2949.800781 1745.011719 2949.800781 1737.039062 C 2949.800781 1729.078125 2956.25 1722.621094 2964.21875 1722.621094 C 2972.191406 1722.621094 2978.648438 1729.078125 2978.648438 1737.039062 ',
    'M 2492.109375 2129.210938 C 2492.109375 2137.179688 2485.648438 2143.640625 2477.691406 2143.640625 C 2469.71875 2143.640625 2463.261719 2137.179688 2463.261719 2129.210938 C 2463.261719 2121.25 2469.71875 2114.789062 2477.691406 2114.789062 C 2485.648438 2114.789062 2492.109375 2121.25 2492.109375 2129.210938 ',
    'M 2010.109375 1951.011719 C 2010.109375 1958.980469 2003.648438 1965.441406 1995.679688 1965.441406 C 1987.710938 1965.441406 1981.25 1958.980469 1981.25 1951.011719 C 1981.25 1943.039062 1987.710938 1936.578125 1995.679688 1936.578125 C 2003.648438 1936.578125 2010.109375 1943.039062 2010.109375 1951.011719 ',
    'M 1416.761719 1703.339844 C 1416.761719 1711.308594 1410.300781 1717.769531 1402.328125 1717.769531 C 1394.371094 1717.769531 1387.910156 1711.308594 1387.910156 1703.339844 C 1387.910156 1695.371094 1394.371094 1688.910156 1402.328125 1688.910156 C 1410.300781 1688.910156 1416.761719 1695.371094 1416.761719 1703.339844 ',
    'M 916.820312 1593.46875 C 916.820312 1601.441406 910.359375 1607.898438 902.394531 1607.898438 C 894.425781 1607.898438 887.964844 1601.441406 887.964844 1593.46875 C 887.964844 1585.5 894.425781 1579.039062 902.394531 1579.039062 C 910.359375 1579.039062 916.820312 1585.5 916.820312 1593.46875 ',
    'M 3398.519531 1659.378906 C 3398.519531 1667.339844 3392.058594 1673.800781 3384.089844 1673.800781 C 3376.128906 1673.800781 3369.671875 1667.339844 3369.671875 1659.378906 C 3369.671875 1651.410156 3376.128906 1644.949219 3384.089844 1644.949219 C 3392.058594 1644.949219 3398.519531 1651.410156 3398.519531 1659.378906 ',
    'M 1372.789062 257.210938 C 1372.789062 265.179688 1366.328125 271.640625 1358.371094 271.640625 C 1350.398438 271.640625 1343.941406 265.179688 1343.941406 257.210938 C 1343.941406 249.25 1350.398438 242.789062 1358.371094 242.789062 C 1366.328125 242.789062 1372.789062 249.25 1372.789062 257.210938 ',
    'M 354.046875 1470.851562 C 354.046875 1478.820312 347.585938 1485.28125 339.617188 1485.28125 C 331.652344 1485.28125 325.191406 1478.820312 325.191406 1470.851562 C 325.191406 1462.890625 331.652344 1456.429688 339.617188 1456.429688 C 347.585938 1456.429688 354.046875 1462.890625 354.046875 1470.851562 ',
    'M 475.167969 1392.21875 C 475.167969 1400.179688 468.707031 1406.640625 460.742188 1406.640625 C 452.773438 1406.640625 446.3125 1400.179688 446.3125 1392.21875 C 446.3125 1384.25 452.773438 1377.789062 460.742188 1377.789062 C 468.707031 1377.789062 475.167969 1384.25 475.167969 1392.21875 ',
    'M 1040.339844 956.679688 C 1040.339844 964.648438 1033.878906 971.109375 1025.921875 971.109375 C 1017.949219 971.109375 1011.488281 964.648438 1011.488281 956.679688 C 1011.488281 948.710938 1017.949219 942.25 1025.921875 942.25 C 1033.878906 942.25 1040.339844 948.710938 1040.339844 956.679688 ',
    'M 1431.191406 896.351562 C 1431.191406 904.320312 1424.730469 910.78125 1416.761719 910.78125 C 1408.789062 910.78125 1402.328125 904.320312 1402.328125 896.351562 C 1402.328125 888.378906 1408.789062 881.921875 1416.761719 881.921875 C 1424.730469 881.921875 1431.191406 888.378906 1431.191406 896.351562 ',
    'M 1363.070312 1208.359375 C 1363.070312 1216.328125 1356.609375 1222.789062 1348.640625 1222.789062 C 1340.671875 1222.789062 1334.210938 1216.328125 1334.210938 1208.359375 C 1334.210938 1200.390625 1340.671875 1193.929688 1348.640625 1193.929688 C 1356.609375 1193.929688 1363.070312 1200.390625 1363.070312 1208.359375 ',
    'M 1383.488281 1329.160156 C 1383.488281 1337.128906 1377.03125 1343.578125 1369.058594 1343.578125 C 1361.101562 1343.578125 1354.640625 1337.128906 1354.640625 1329.160156 C 1354.640625 1321.191406 1361.101562 1314.730469 1369.058594 1314.730469 C 1377.03125 1314.730469 1383.488281 1321.191406 1383.488281 1329.160156 ',
    'M 1203.851562 1593.46875 C 1203.851562 1601.441406 1197.398438 1607.898438 1189.429688 1607.898438 C 1181.460938 1607.898438 1175 1601.441406 1175 1593.46875 C 1175 1585.5 1181.460938 1579.039062 1189.429688 1579.039062 C 1197.398438 1579.039062 1203.851562 1585.5 1203.851562 1593.46875 ',
    'M 2869.769531 1349.238281 C 2869.769531 1359.078125 2861.789062 1367.050781 2851.960938 1367.050781 C 2842.121094 1367.050781 2834.148438 1359.078125 2834.148438 1349.238281 C 2834.148438 1339.398438 2842.121094 1331.429688 2851.960938 1331.429688 C 2861.789062 1331.429688 2869.769531 1339.398438 2869.769531 1349.238281 ',
    'M 2575.691406 1001.078125 C 2575.691406 1010.910156 2567.71875 1018.890625 2557.890625 1018.890625 C 2548.050781 1018.890625 2540.078125 1010.910156 2540.078125 1001.078125 C 2540.078125 991.238281 2548.050781 983.269531 2557.890625 983.269531 C 2567.71875 983.269531 2575.691406 991.238281 2575.691406 1001.078125 ',
    'M 1881.28125 1435.53125 C 1881.28125 1445.359375 1873.308594 1453.339844 1863.46875 1453.339844 C 1853.640625 1453.339844 1845.660156 1445.359375 1845.660156 1435.53125 C 1845.660156 1425.691406 1853.640625 1417.71875 1863.46875 1417.71875 C 1873.308594 1417.71875 1881.28125 1425.691406 1881.28125 1435.53125 ',
    'M 516.746094 1139.539062 C 516.746094 1149.371094 508.773438 1157.339844 498.9375 1157.339844 C 489.101562 1157.339844 481.128906 1149.371094 481.128906 1139.539062 C 481.128906 1129.699219 489.101562 1121.730469 498.9375 1121.730469 C 508.773438 1121.730469 516.746094 1129.699219 516.746094 1139.539062 ',
  ];

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 3735.49 2300">
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="50" flood-color="#3BB7FF" flood-opacity="1" />
        </filter>
      </defs>

      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14845.195312 8846.015625 L 19488.90625 8846.015625 L 19993.203125 9350.3125 L 22045.195312 9350.3125 L 22573.085938 8822.382812 L 24618.789062 8822.382812 L 25257.382812 8183.90625 L 25257.382812 3341.289062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14023.28125 8396.601562 L 24251.210938 8396.601562 L 24776.914062 7870.898438 L 24776.914062 4137.890625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 23914.101562 7936.992188 L 20954.414062 7936.992188 L 20197.695312 7180.3125 L 17122.109375 7180.3125 L 16153.59375 6211.71875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 22780.507812 15507.8125 L 19400.117188 15507.8125 L 18765.3125 16142.617188 L 16863.007812 16142.617188 L 16123.007812 16882.617188 L 16123.007812 20192.304688 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 15090.3125 17404.296875 L 13834.882812 17404.296875 L 13141.992188 16711.289062 L 7478.984375 16711.289062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 12639.21875 17404.296875 L 6756.679688 17404.296875 L 5972.695312 18188.28125 L 4174.609375 18188.28125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25443.515625 8846.015625 L 26121.71875 9524.296875 L 30048.59375 9524.296875 L 30736.71875 8836.210938 L 33840.898438 8836.210938 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25905.585938 8396.601562 L 26454.609375 8945.585938 L 29642.1875 8945.585938 L 30346.289062 8241.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17122.109375 16610.78125 L 20954.414062 16610.78125 L 21548.007812 17204.296875 L 22780.507812 17204.296875 L 24136.71875 18560.507812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17122.109375 17057.8125 L 20513.28125 17057.8125 L 21403.398438 17947.890625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 19042.695312 7936.992188 L 12792.382812 7936.992188 L 12221.992188 7366.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 28253.789062 10424.882812 L 30562.695312 10424.882812 L 31338.28125 9649.21875 L 32523.007812 9649.21875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 15427.304688 17947.890625 L 15427.304688 20958.28125 L 14661.40625 21724.296875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14845.195312 19395.703125 L 14845.195312 20560 L 13583.710938 21821.484375 L 13583.710938 22857.890625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 8778.828125 15419.21875 L 6243.164062 15419.21875 L 5411.367188 16251.015625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 28663.085938 15824.882812 L 30777.109375 15824.882812 L 31784.21875 16831.914062 L 33840.898438 16831.914062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 29428.984375 16449.414062 L 30956.601562 17976.992188 L 30956.601562 19579.609375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 30562.695312 16466.484375 L 31975.78125 17879.609375 L 31975.78125 18721.71875 L 33015.585938 19761.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 23914.101562 7366.484375 L 21403.398438 7366.484375 L 19956.796875 5919.882812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 9023.945312 9495.3125 L 7095.117188 9495.3125 L 4640.78125 7041.015625 L 2712.421875 7041.015625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 11528.085938 8945.585938 L 7478.984375 8945.585938 L 6379.023438 7845.585938 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 22137.109375 16610.78125 L 24776.914062 16610.78125 L 25557.695312 17391.601562 L 28253.789062 17391.601562 L 29349.296875 18486.992188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25905.585938 7366.484375 L 25905.585938 2606.015625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 26763.515625 7845.585938 L 28938.789062 7845.585938 L 30624.21875 6160.3125 L 32523.007812 6160.3125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 29642.1875 8059.609375 L 30361.796875 7340 L 33015.585938 7340 L 34676.992188 5678.59375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14446.914062 18113.984375 L 10923.515625 18113.984375 L 9027.421875 20010.117188 L 5954.648438 20010.117188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 29573.28125 18560.507812 C 29573.28125 18480.78125 29508.710938 18416.210938 29428.984375 18416.210938 C 29349.414062 18416.210938 29284.804688 18480.78125 29284.804688 18560.507812 C 29284.804688 18640.117188 29349.414062 18704.6875 29428.984375 18704.6875 C 29508.710938 18704.6875 29573.28125 18640.117188 29573.28125 18560.507812 Z M 29573.28125 18560.507812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 5954.648438 20010.117188 C 5954.648438 19930.390625 5890.039062 19865.78125 5810.351562 19865.78125 C 5730.703125 19865.78125 5666.09375 19930.390625 5666.09375 20010.117188 C 5666.09375 20089.804688 5730.703125 20154.414062 5810.351562 20154.414062 C 5890.039062 20154.414062 5954.648438 20089.804688 5954.648438 20010.117188 Z M 5954.648438 20010.117188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 7478.984375 16711.289062 C 7478.984375 16631.71875 7414.414062 16567.109375 7334.726562 16567.109375 C 7255.039062 16567.109375 7190.46875 16631.71875 7190.46875 16711.289062 C 7190.46875 16791.015625 7255.039062 16855.585938 7334.726562 16855.585938 C 7414.414062 16855.585938 7478.984375 16791.015625 7478.984375 16711.289062 Z M 7478.984375 16711.289062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 9067.34375 15419.21875 C 9067.34375 15339.492188 9002.773438 15275 8923.085938 15275 C 8843.398438 15275 8778.828125 15339.492188 8778.828125 15419.21875 C 8778.828125 15498.90625 8843.398438 15563.515625 8923.085938 15563.515625 C 9002.773438 15563.515625 9067.34375 15498.90625 9067.34375 15419.21875 Z M 9067.34375 15419.21875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 34129.492188 16831.914062 C 34129.492188 16752.1875 34064.882812 16687.617188 33985.195312 16687.617188 C 33905.507812 16687.617188 33840.898438 16752.1875 33840.898438 16831.914062 C 33840.898438 16911.601562 33905.507812 16976.210938 33985.195312 16976.210938 C 34064.882812 16976.210938 34129.492188 16911.601562 34129.492188 16831.914062 Z M 34129.492188 16831.914062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25919.492188 8307.382812 C 25919.492188 8227.695312 25854.882812 8163.085938 25775.3125 8163.085938 C 25695.585938 8163.085938 25631.015625 8227.695312 25631.015625 8307.382812 C 25631.015625 8387.109375 25695.585938 8451.71875 25775.3125 8451.71875 C 25854.882812 8451.71875 25919.492188 8387.109375 25919.492188 8307.382812 Z M 25919.492188 8307.382812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 32821.484375 6167.890625 C 32821.484375 6088.28125 32756.914062 6023.710938 32677.304688 6023.710938 C 32597.617188 6023.710938 32533.007812 6088.28125 32533.007812 6167.890625 C 32533.007812 6247.617188 32597.617188 6312.1875 32677.304688 6312.1875 C 32756.914062 6312.1875 32821.484375 6247.617188 32821.484375 6167.890625 Z M 32821.484375 6167.890625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25401.601562 3196.992188 C 25401.601562 3117.304688 25336.992188 3052.695312 25257.382812 3052.695312 C 25177.695312 3052.695312 25113.085938 3117.304688 25113.085938 3196.992188 C 25113.085938 3276.71875 25177.695312 3341.289062 25257.382812 3341.289062 C 25336.992188 3341.289062 25401.601562 3276.71875 25401.601562 3196.992188 Z M 25401.601562 3196.992188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 16217.695312 6160.3125 C 16217.695312 6080.585938 16153.085938 6016.015625 16073.515625 6016.015625 C 15993.789062 6016.015625 15929.21875 6080.585938 15929.21875 6160.3125 C 15929.21875 6239.882812 15993.789062 6304.492188 16073.515625 6304.492188 C 16153.085938 6304.492188 16217.695312 6239.882812 16217.695312 6160.3125 Z M 16217.695312 6160.3125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 12281.09375 7269.21875 C 12281.09375 7189.492188 12216.484375 7124.882812 12136.796875 7124.882812 C 12057.109375 7124.882812 11992.5 7189.492188 11992.5 7269.21875 C 11992.5 7348.789062 12057.109375 7413.398438 12136.796875 7413.398438 C 12216.484375 7413.398438 12281.09375 7348.789062 12281.09375 7269.21875 Z M 12281.09375 7269.21875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 6446.992188 7746.210938 C 6446.992188 7666.601562 6382.382812 7601.992188 6302.734375 7601.992188 C 6223.046875 7601.992188 6158.4375 7666.601562 6158.4375 7746.210938 C 6158.4375 7825.898438 6223.046875 7890.507812 6302.734375 7890.507812 C 6382.382812 7890.507812 6446.992188 7825.898438 6446.992188 7746.210938 Z M 6446.992188 7746.210938 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14845.195312 8836.210938 C 14845.195312 8756.601562 14780.585938 8691.992188 14700.898438 8691.992188 C 14621.289062 8691.992188 14556.71875 8756.601562 14556.71875 8836.210938 C 14556.71875 8915.898438 14621.289062 8980.507812 14700.898438 8980.507812 C 14780.585938 8980.507812 14845.195312 8915.898438 14845.195312 8836.210938 Z M 14845.195312 8836.210938 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 26049.882812 7510.78125 C 26049.882812 7431.09375 25985.3125 7366.484375 25905.585938 7366.484375 C 25826.015625 7366.484375 25761.40625 7431.09375 25761.40625 7510.78125 C 25761.40625 7590.507812 25826.015625 7655.117188 25905.585938 7655.117188 C 25985.3125 7655.117188 26049.882812 7590.507812 26049.882812 7510.78125 Z M 26049.882812 7510.78125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 32811.484375 9649.21875 C 32811.484375 9569.609375 32746.914062 9505 32667.304688 9505 C 32587.617188 9505 32523.007812 9569.609375 32523.007812 9649.21875 C 32523.007812 9728.90625 32587.617188 9793.515625 32667.304688 9793.515625 C 32746.914062 9793.515625 32811.484375 9728.90625 32811.484375 9649.21875 Z M 32811.484375 9649.21875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14675.390625 21858.515625 C 14675.390625 21778.789062 14610.78125 21714.296875 14531.210938 21714.296875 C 14451.484375 21714.296875 14386.914062 21778.789062 14386.914062 21858.515625 C 14386.914062 21938.203125 14451.484375 22002.8125 14531.210938 22002.8125 C 14610.78125 22002.8125 14675.390625 21938.203125 14675.390625 21858.515625 Z M 14675.390625 21858.515625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 15571.601562 17796.289062 C 15571.601562 17716.601562 15506.992188 17651.992188 15427.304688 17651.992188 C 15347.695312 17651.992188 15283.085938 17716.601562 15283.085938 17796.289062 C 15283.085938 17875.898438 15347.695312 17940.507812 15427.304688 17940.507812 C 15506.992188 17940.507812 15571.601562 17875.898438 15571.601562 17796.289062 Z M 15571.601562 17796.289062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 23069.101562 15507.8125 C 23069.101562 15428.203125 23004.492188 15363.59375 22924.804688 15363.59375 C 22845.117188 15363.59375 22780.507812 15428.203125 22780.507812 15507.8125 C 22780.507812 15587.5 22845.117188 15652.109375 22924.804688 15652.109375 C 23004.492188 15652.109375 23069.101562 15587.5 23069.101562 15507.8125 Z M 23069.101562 15507.8125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17151.484375 17057.8125 C 17151.484375 16978.085938 17086.914062 16913.515625 17007.1875 16913.515625 C 16927.5 16913.515625 16863.007812 16978.085938 16863.007812 17057.8125 C 16863.007812 17137.5 16927.5 17202.109375 17007.1875 17202.109375 C 17086.914062 17202.109375 17151.484375 17137.5 17151.484375 17057.8125 Z M 17151.484375 17057.8125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />

      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 12927.8125 17404.296875 C 12927.8125 17324.609375 12863.203125 17260 12783.515625 17260 C 12703.789062 17260 12639.21875 17324.609375 12639.21875 17404.296875 C 12639.21875 17483.90625 12703.789062 17548.515625 12783.515625 17548.515625 C 12863.203125 17548.515625 12927.8125 17483.90625 12927.8125 17404.296875 Z M 12927.8125 17404.296875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 29465 16328.398438 C 29465 16248.710938 29400.390625 16184.101562 29320.703125 16184.101562 C 29241.09375 16184.101562 29176.484375 16248.710938 29176.484375 16328.398438 C 29176.484375 16408.085938 29241.09375 16472.695312 29320.703125 16472.695312 C 29400.390625 16472.695312 29465 16408.085938 29465 16328.398438 Z M 29465 16328.398438 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 30619.101562 16360.507812 C 30619.101562 16280.898438 30554.492188 16216.289062 30474.804688 16216.289062 C 30395.195312 16216.289062 30330.585938 16280.898438 30330.585938 16360.507812 C 30330.585938 16440.195312 30395.195312 16504.804688 30474.804688 16504.804688 C 30554.492188 16504.804688 30619.101562 16440.195312 30619.101562 16360.507812 Z M 30619.101562 16360.507812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 34931.015625 5583.789062 C 34931.015625 5504.101562 34866.40625 5439.492188 34786.796875 5439.492188 C 34707.109375 5439.492188 34642.5 5504.101562 34642.5 5583.789062 C 34642.5 5663.515625 34707.109375 5728.085938 34786.796875 5728.085938 C 34866.40625 5728.085938 34931.015625 5663.515625 34931.015625 5583.789062 Z M 34931.015625 5583.789062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 24202.695312 7366.484375 C 24202.695312 7286.914062 24138.085938 7222.304688 24058.398438 7222.304688 C 23978.710938 7222.304688 23914.101562 7286.914062 23914.101562 7366.484375 C 23914.101562 7446.210938 23978.710938 7510.78125 24058.398438 7510.78125 C 24138.085938 7510.78125 24202.695312 7446.210938 24202.695312 7366.484375 Z M 24202.695312 7366.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 2712.421875 7041.015625 C 2712.421875 6961.289062 2647.851562 6896.71875 2568.164062 6896.71875 C 2488.515625 6896.71875 2423.90625 6961.289062 2423.90625 7041.015625 C 2423.90625 7120.703125 2488.515625 7185.3125 2568.164062 7185.3125 C 2647.851562 7185.3125 2712.421875 7120.703125 2712.421875 7041.015625 Z M 2712.421875 7041.015625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 14989.492188 19251.484375 C 14989.492188 19171.796875 14924.882812 19107.1875 14845.195312 19107.1875 C 14765.507812 19107.1875 14700.898438 19171.796875 14700.898438 19251.484375 C 14700.898438 19331.210938 14765.507812 19395.703125 14845.195312 19395.703125 C 14924.882812 19395.703125 14989.492188 19331.210938 14989.492188 19251.484375 Z M 14989.492188 19251.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 24395 18684.6875 C 24395 18605.117188 24330.390625 18540.507812 24250.703125 18540.507812 C 24171.09375 18540.507812 24106.484375 18605.117188 24106.484375 18684.6875 C 24106.484375 18764.414062 24171.09375 18828.984375 24250.703125 18828.984375 C 24330.390625 18828.984375 24395 18764.414062 24395 18684.6875 Z M 24395 18684.6875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />

      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 8175.742188 12752.890625 L 14099.21875 12752.890625 L 14914.492188 11937.617188 L 28519.609375 11937.617188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 16305.117188 12877.382812 L 17700.78125 14273.007812 L 24434.492188 14273.007812 L 25603.710938 15442.304688 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 18634.6875 11074.6875 L 17693.085938 10133.203125 L 5479.609375 10133.203125 L 4421.445312 9075 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 22351.09375 12964.609375 L 33013.203125 12964.609375 L 34156.601562 14108.007812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17122.109375 10721.484375 L 3396.171875 10721.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 31991.914062 12428.90625 L 20186.015625 12428.90625 L 19499.882812 13115 L 17694.101562 13115 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 19777.5 11334.21875 L 30807.1875 11334.21875 L 31753.085938 10388.398438 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 13690.585938 12094.101562 L 5193.632812 12094.101562 L 4607.421875 11507.8125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 10299.609375 15863.203125 L 13581.40625 15863.203125 L 14167.617188 16449.414062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 21356.992188 10243.085938 L 24638.710938 10243.085938 L 25225 10829.296875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 13486.40625 13346.40625 L 4172.34375 13346.40625 L 3154.179688 14364.609375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 4989.375 14034.609375 L 14426.015625 14034.609375 L 15609.882812 15218.59375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 18634.6875 13741.09375 L 26885.507812 13741.09375 L 27544.492188 14400.117188 L 32523.007812 14400.117188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 23536.289062 9724.882812 L 24966.09375 9724.882812 L 25666.015625 10424.882812 L 27253.203125 10424.882812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 7767.539062 14663.59375 L 9197.304688 14663.59375 L 9897.265625 15363.59375 L 11484.414062 15363.59375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25578.90625 14303.28125 L 26313.59375 14303.28125 L 27241.09375 15230.703125 L 27241.09375 16156.289062 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17694.101562 15590.117188 L 16959.296875 15590.117188 L 16031.914062 14662.695312 L 16031.914062 13737.109375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 6255.742188 11399.6875 L 12996.210938 11399.6875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 11894.296875 9495.3125 L 18634.6875 9495.3125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 27947.695312 15013.59375 L 31338.28125 15013.59375 L 32149.609375 15824.882812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 27947.695312 13624.492188 L 31991.914062 13624.492188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 16863.007812 14303.28125 L 17503.398438 14943.710938 L 23536.289062 14943.710938 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 3223.867188 14482.304688 C 3223.867188 14402.695312 3159.257812 14338.085938 3079.609375 14338.085938 C 2999.921875 14338.085938 2935.3125 14402.695312 2935.3125 14482.304688 C 2935.3125 14561.992188 2999.921875 14626.601562 3079.609375 14626.601562 C 3159.257812 14626.601562 3223.867188 14561.992188 3223.867188 14482.304688 Z M 3223.867188 14482.304688 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17410.703125 10721.484375 C 17410.703125 10641.796875 17346.09375 10577.1875 17266.40625 10577.1875 C 17186.71875 10577.1875 17122.109375 10641.796875 17122.109375 10721.484375 C 17122.109375 10801.09375 17186.71875 10865.703125 17266.40625 10865.703125 C 17346.09375 10865.703125 17410.703125 10801.09375 17410.703125 10721.484375 Z M 17410.703125 10721.484375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 19777.5 11334.21875 C 19777.5 11254.609375 19712.890625 11190 19633.203125 11190 C 19553.515625 11190 19488.90625 11254.609375 19488.90625 11334.21875 C 19488.90625 11413.90625 19553.515625 11478.515625 19633.203125 11478.515625 C 19712.890625 11478.515625 19777.5 11413.90625 19777.5 11334.21875 Z M 19777.5 11334.21875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25443.515625 10926.601562 C 25443.515625 10846.992188 25378.90625 10782.382812 25299.21875 10782.382812 C 25219.492188 10782.382812 25155 10846.992188 25155 10926.601562 C 25155 11006.289062 25219.492188 11070.898438 25299.21875 11070.898438 C 25378.90625 11070.898438 25443.515625 11006.289062 25443.515625 10926.601562 Z M 25443.515625 10926.601562 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 23536.289062 9724.882812 C 23536.289062 9645.195312 23471.71875 9580.585938 23391.992188 9580.585938 C 23312.382812 9580.585938 23247.8125 9645.195312 23247.8125 9724.882812 C 23247.8125 9804.609375 23312.382812 9869.21875 23391.992188 9869.21875 C 23471.71875 9869.21875 23536.289062 9804.609375 23536.289062 9724.882812 Z M 23536.289062 9724.882812 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 18923.203125 9495.3125 C 18923.203125 9415.585938 18858.59375 9351.015625 18778.984375 9351.015625 C 18699.296875 9351.015625 18634.6875 9415.585938 18634.6875 9495.3125 C 18634.6875 9575 18699.296875 9639.609375 18778.984375 9639.609375 C 18858.59375 9639.609375 18923.203125 9575 18923.203125 9495.3125 Z M 18923.203125 9495.3125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 7767.539062 14663.59375 C 7767.539062 14583.90625 7702.929688 14519.296875 7623.242188 14519.296875 C 7543.59375 14519.296875 7478.984375 14583.90625 7478.984375 14663.59375 C 7478.984375 14743.28125 7543.59375 14807.890625 7623.242188 14807.890625 C 7702.929688 14807.890625 7767.539062 14743.28125 7767.539062 14663.59375 Z M 7767.539062 14663.59375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 11773.007812 15363.59375 C 11773.007812 15283.90625 11708.398438 15219.296875 11628.710938 15219.296875 C 11548.984375 15219.296875 11484.414062 15283.90625 11484.414062 15363.59375 C 11484.414062 15443.28125 11548.984375 15507.8125 11628.710938 15507.8125 C 11708.398438 15507.8125 11773.007812 15443.28125 11773.007812 15363.59375 Z M 11773.007812 15363.59375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 17982.617188 15590.117188 C 17982.617188 15510.390625 17918.007812 15445.898438 17838.28125 15445.898438 C 17758.59375 15445.898438 17694.101562 15510.390625 17694.101562 15590.117188 C 17694.101562 15669.804688 17758.59375 15734.414062 17838.28125 15734.414062 C 17918.007812 15734.414062 17982.617188 15669.804688 17982.617188 15590.117188 Z M 17982.617188 15590.117188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 25545 14303.28125 C 25545 14223.59375 25480.390625 14158.984375 25400.78125 14158.984375 C 25321.09375 14158.984375 25256.484375 14223.59375 25256.484375 14303.28125 C 25256.484375 14383.007812 25321.09375 14447.617188 25400.78125 14447.617188 C 25480.390625 14447.617188 25545 14383.007812 25545 14303.28125 Z M 25545 14303.28125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 32811.484375 14400.117188 C 32811.484375 14320.390625 32746.914062 14255.78125 32667.304688 14255.78125 C 32587.617188 14255.78125 32523.007812 14320.390625 32523.007812 14400.117188 C 32523.007812 14479.6875 32587.617188 14544.296875 32667.304688 14544.296875 C 32746.914062 14544.296875 32811.484375 14479.6875 32811.484375 14400.117188 Z M 32811.484375 14400.117188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 23824.804688 14943.710938 C 23824.804688 14863.984375 23760.195312 14799.414062 23680.585938 14799.414062 C 23600.898438 14799.414062 23536.289062 14863.984375 23536.289062 14943.710938 C 23536.289062 15023.398438 23600.898438 15088.007812 23680.585938 15088.007812 C 23760.195312 15088.007812 23824.804688 15023.398438 23824.804688 14943.710938 Z M 23824.804688 14943.710938 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 32293.789062 12428.90625 C 32293.789062 12349.296875 32229.296875 12284.6875 32149.609375 12284.6875 C 32069.882812 12284.6875 32005.3125 12349.296875 32005.3125 12428.90625 C 32005.3125 12508.59375 32069.882812 12573.203125 32149.609375 12573.203125 C 32229.296875 12573.203125 32293.789062 12508.59375 32293.789062 12428.90625 Z M 32293.789062 12428.90625 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 10}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 18636.210938 13741.09375 C 18636.210938 13661.40625 18571.601562 13596.796875 18491.914062 13596.796875 C 18412.304688 13596.796875 18347.695312 13661.40625 18347.695312 13741.09375 C 18347.695312 13820.78125 18412.304688 13885.390625 18491.914062 13885.390625 C 18571.601562 13885.390625 18636.210938 13820.78125 18636.210938 13741.09375 Z M 18636.210938 13741.09375 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />

      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 6243.164062 11399.6875 C 6243.164062 11320 6178.554688 11255.507812 6098.90625 11255.507812 C 6019.21875 11255.507812 5954.648438 11320 5954.648438 11399.6875 C 5954.648438 11479.414062 6019.21875 11543.984375 6098.90625 11543.984375 C 6178.554688 11543.984375 6243.164062 11479.414062 6243.164062 11399.6875 Z M 6243.164062 11399.6875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 16386.601562 12771.992188 C 16386.601562 12692.304688 16322.109375 12627.695312 16242.382812 12627.695312 C 16162.695312 12627.695312 16098.085938 12692.304688 16098.085938 12771.992188 C 16098.085938 12851.71875 16162.695312 12916.210938 16242.382812 12916.210938 C 16322.109375 12916.210938 16386.601562 12851.71875 16386.601562 12771.992188 Z M 16386.601562 12771.992188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 32293.789062 13624.492188 C 32293.789062 13544.804688 32229.296875 13480.195312 32149.609375 13480.195312 C 32069.882812 13480.195312 32005.3125 13544.804688 32005.3125 13624.492188 C 32005.3125 13704.21875 32069.882812 13768.789062 32149.609375 13768.789062 C 32229.296875 13768.789062 32293.789062 13704.21875 32293.789062 13624.492188 Z M 32293.789062 13624.492188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 27913.90625 13624.492188 C 27913.90625 13544.804688 27849.296875 13480.195312 27769.609375 13480.195312 C 27689.882812 13480.195312 27625.3125 13544.804688 27625.3125 13624.492188 C 27625.3125 13704.21875 27689.882812 13768.789062 27769.609375 13768.789062 C 27849.296875 13768.789062 27913.90625 13704.21875 27913.90625 13624.492188 Z M 27913.90625 13624.492188 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 13242.617188 11399.6875 C 13242.617188 11320 13178.007812 11255.507812 13098.28125 11255.507812 C 13018.59375 11255.507812 12953.984375 11320 12953.984375 11399.6875 C 12953.984375 11479.414062 13018.59375 11543.984375 13098.28125 11543.984375 C 13178.007812 11543.984375 13242.617188 11479.414062 13242.617188 11399.6875 Z M 13242.617188 11399.6875 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />
      <motion.path
        initial={{ pathLength: styleInactive ? 1 : 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration, delay }}
        fill="none"
        filter={styleInactive ? undefined : 'url(#glow)'}
        stroke-width={strokeWidth * 20}
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke={styleInactive ? inactiveColor : color}
        stroke-opacity={styleInactive ? '0.2' : '1'}
        stroke-miterlimit="10"
        d="M 4463.125 8990.3125 C 4463.125 8910.585938 4398.554688 8846.015625 4318.867188 8846.015625 C 4239.21875 8846.015625 4174.609375 8910.585938 4174.609375 8990.3125 C 4174.609375 9070 4239.21875 9134.609375 4318.867188 9134.609375 C 4398.554688 9134.609375 4463.125 9070 4463.125 8990.3125 Z M 4463.125 8990.3125 "
        transform="matrix(0.1, 0, 0, -0.1, 0, 2543)"
      />

      {points.map((d) => {
        return (
          <>
            <motion.path
              key={d + 1}
              className="points"
              initial={{ pathLength: styleInactive ? 1 : 0, scale: styleInactive ? 1 : 0 }}
              animate={{ pathLength: 1, scale: 1 }}
              transition={{ duration: duration / 2, delay: duration + delay }}
              fill={inactiveColor}
              style={
                styleInactive
                  ? { opacity: 0 }
                  : {
                      filter: 'blur(4px)',
                      opacity: 0.7,
                    }
              }
              d={d}
            />
            <motion.path
              key={d + 2}
              className="points"
              initial={{ pathLength: styleInactive ? 1 : 0, scale: styleInactive ? 1 : 0 }}
              animate={{ pathLength: 1, scale: 1 }}
              transition={{ duration: duration / 2, delay: duration + delay }}
              style={styleInactive ? { opacity: 0.5 } : {}}
              fill-rule="nonzero"
              fill={styleInactive ? inactiveColor : color}
              fill-opacity="1"
              d={d}
            />
          </>
        );
      })}
    </svg>
  );
};

export default Circuit;
